import { render, staticRenderFns } from "./UnassignedTickets.vue?vue&type=template&id=4e6c99ce&scoped=true&"
import script from "./UnassignedTickets.vue?vue&type=script&lang=js&"
export * from "./UnassignedTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c99ce",
  null
  
)

export default component.exports